import type { ChangeEvent, RefObject } from "react";

interface FieldProps {
  id: string;
  label: string;
  required?: boolean;
  type?: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  fullWidth?: boolean;
  showLabel?: boolean;
  min?: string;
  max?: string;
  inputRef?: RefObject<HTMLInputElement>;
}

export function AddRecipientField({
  id,
  label,
  required,
  type = "text",
  value,
  onChange,
  error,
  fullWidth,
  showLabel,
  min,
  max,
  inputRef,
}: FieldProps) {
  return (
    <div className={fullWidth ? "w-full" : "flex-1 min-w-0"}>
      <label
        htmlFor={id}
        className={
          showLabel
            ? "block mb-1.5 font-lato text-[12px] font-semibold text-graphite uppercase tracking-[0.8px]"
            : "sr-only"
        }
      >
        {label}
        {required ? " *" : ""}
      </label>
      <input
        ref={inputRef}
        id={id}
        type={type}
        value={value}
        min={min}
        max={max}
        onChange={onChange}
        placeholder={showLabel ? undefined : required ? `${label} *` : label}
        className={[
          "w-full h-10.5 px-3.5 border rounded-btn bg-white",
          "font-lato text-[16px] text-rodeo-black placeholder:text-graphite",
          "outline-none transition-colors",
          error ? "border-good-wine focus:border-good-wine" : "border-smoke focus:border-dark-dust",
        ].join(" ")}
        aria-required={required}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
      />
      {error && (
        <p id={`${id}-error`} className="mt-1 font-lato text-[12px] text-good-wine">
          {error}
        </p>
      )}
    </div>
  );
}
